import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { AppDocIframeComponent } from './app-doc-iframe/app-doc-iframe.component'
import { HomeComponent } from './home/home.component'

const routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'se-household-setup',
    loadChildren: () => import('./se-household-setup-docs/se-household-setup-docs.module')
      .then(m => m.SeHouseholdSetupDocsModule)
  },
  {
    path: 'se-household-info',
    loadChildren: () => import('./se-household-info-docs/se-household-info-docs.module')
      .then(m => m.SeHouseholdInfoDocsModule)
  },
  {
    path: 'se-inbox',
    loadChildren: () => import('./se-inbox-docs/se-inbox-docs.module')
      .then(m => m.SeInboxDocsModule)
  },
  {
    path: 'se-missing-persona-info',
    loadChildren: () => import('./se-missing-persona-info-docs/se-missing-persona-info-docs.module')
      .then(m => m.SeMissingPersonaInfoDocsModule)
  },
  {
    path: 'se-my-sportsengine',
    loadChildren: () => import('./se-my-sportsengine-docs/se-my-sportsengine-docs.module')
      .then(m => m.SeMySportsengineDocsModule)
  },
  {
    path: 'se-persona-picker',
    loadChildren: () => import('./se-persona-picker-docs/se-persona-picker-docs.module')
      .then(m => m.SePersonaPickerDocsModule)
  },
  {
    path: 'se-registration-ui',
    loadChildren: () => import('./se-registration-ui-docs/se-registration-ui-docs.module')
      .then(m => m.SeRegistrationUiDocsModule)
  },
  {
    path: 'shared',
    loadChildren: () => import('./shared-docs/shared-docs.module')
      .then(m => m.SharedDocsModule)
  },
  {
    path: 'apps/:app',
    component: AppDocIframeComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class DocsAppRoutingModule { }
